import React from 'react';

import {ReactComponent as IconAfs} from '../../assets/icons/logo-afs.svg';
import { ButtonDefaultLink } from '../ui-components';

import './copyright.scss';

const Copyright = () => (
  <div className='copyright'>
    <ButtonDefaultLink
      to='https://allfuneral.com/'
    >
      <IconAfs className='copyright__icon'/>
    </ButtonDefaultLink>
  </div>
);

export default Copyright;
